import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import Paper from '@mui/material/Paper/Paper';
import Stack from '@mui/material/Stack/Stack';
import Typography from '@mui/material/Typography/Typography';

import WaveUISortableContainer from '@/shared/components/widgets/WaveUISortableContainer';

import Tile from '../../components/Tile/Tile';
import useTile from '../../components/Tile/hooks/useTile';

type TilesPanelProps = {
  tileState: ReturnType<typeof useTile>;
};

const TilesPanel: FC<TilesPanelProps> = ({ tileState }) => {
  const { t } = useTranslation(['checkout']);

  return (
    <Paper sx={{ p: 2 }}>
      <Stack spacing={2}>
        <Typography variant='body1'>{t('checkout:paymentMethods')}</Typography>

        <WaveUISortableContainer
          items={tileState.tilesList}
          getUpdatedItems={tileState.setTilesList}
          onClickOutsideCallback={() => tileState.setTilesMode('idle')}
          componentRenderer={({ props: tile, index, columnsLength }) => {
            const actionKey =
              tile.action as keyof typeof tileState.tileActionHandlers;
            const idx = index || 0;

            return (
              <Tile
                {...tile}
                index={idx + 1}
                mode='idle'
                columnsLength={columnsLength}
                containerProps={{
                  ...tileState.longPressAttrs,
                  onClick: () => {
                    if (tileState.tilesMode === 'edit') return;
                    tileState.tileActionHandlers[actionKey].trigger();
                  },
                }}
              />
            );
          }}
        />
      </Stack>
    </Paper>
  );
};

export default TilesPanel;
